export default __webpack_public_path__ + "static/twoColumnsPresentationReadyReports-325c9b636fe4ed15b54090b4130ed70d.jpg";